import useHomePageVideo from "@hooks/useBrightcoveVideo/useHomePageVideo";
import { type LatestVideoResponse } from "@transformer/useBrightcoveResponse";

import MediaCard from "./MediaCard";
import { MediaVariant, Variant } from "./types/MediaVariant.d";

export type VideoPackageProps = {
  openVideoDialog: (source: string, variant: Variant) => void;
  variant?: Variant;
};

export default function VideoPackage({
  openVideoDialog,
  variant = MediaVariant.VIDEOS,
}: VideoPackageProps) {
  const { videos } = useHomePageVideo({ variant });
  const videoItems = Array.isArray(videos) ? videos : [];

  return (
    <>
      {videoItems.length > 0 ? (
        <>
          <MediaCard<LatestVideoResponse>
            variant={variant}
            renderedThumbnail={videoItems.slice(0, 10)}
            handleOnClickCallback={(source) => {
              openVideoDialog(source, variant);
            }}
            {...(variant === MediaVariant.VIDEOS && {
              moreLink: {
                destination: "videos",
              },
            })}
          />
        </>
      ) : null}
    </>
  );
}
